import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import CopyToClipboard from 'app/components/CopyToClipboard';

interface MetricValueProps {
  label: string;
  value: unknown;
  onClick?: () => void;
}

const stringifyMetricValue = (value: unknown): string => {
  if (typeof value === 'object' && value !== null) {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

const MetricValue: React.FC<MetricValueProps> = ({ label, value, onClick }) => {
  const text = stringifyMetricValue(value);
  const truncatedStyles = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <Tooltip
        title={
          <Box sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: 240, overflow: 'auto' }}>
            {text}
          </Box>
        }
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {onClick ? (
            <Button
              size="small"
              variant="text"
              onClick={onClick}
              aria-label={`View failed records (${text})`}
              sx={{ ...truncatedStyles, maxWidth: '100%', textTransform: 'none', color: '#b45309', textDecoration: 'underline', p: 0, justifyContent: 'flex-start' }}
            >
              {text}
            </Button>
          ) : (
            <Typography variant="body2" sx={{ ...truncatedStyles, color: '#374151' }}>
              {text}
            </Typography>
          )}
        </Box>
      </Tooltip>
      <CopyToClipboard
        text={text}
        aria-label={`Copy ${label} value`}
        tooltipTitle={`Copy full ${label} value`}
        sx={{ flexShrink: 0, ml: 0, color: '#6b7280' }}
      />
    </Box>
  );
};

export default MetricValue;
